import { useOutletContext, } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import ConfirmationModal from '../../../../components/ConfirmationModal'

import { hasPermission } from '../../../../utils/utils.js'

const OrganizationAppConfigModal = function ({ showSignal, cancelConfig, applyConfig, organization }) {

	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()

	let domain = organization.management && organization.management.domain ? organization.management.domain : "Management domain error"

	const isEditDisabled = useComputed(() => { return hasPermission(userPermissions, "appRecord", "canEdit") })

	const showConfirmOrganizationAppConfigModalSignal = useSignal(false)

	const promptConfirmConfig = function () {
		showSignal.value = false
		showConfirmOrganizationAppConfigModalSignal.value = true
	}

	return (<>
		<Modal id="appConfigModal" show={showSignal.value} onHide={cancelConfig}>
			<Modal.Header closeButton>
				<Modal.Title className="modal-title">Domains &amp; App Names</Modal.Title>
			</Modal.Header>
			<Form id='appConfig' name='appConfig' className="form-horizontal newvalidation">
				<Modal.Body>
					<p>
						<b>Warning</b>: Do not modify this page until both parties are properly set up to accept the new domain, subdomain, and app name values. Putting improper values can prevent all users from this account and child accounts from accessing the listed apps.
					</p>
					<p>
						All child accounts under this account will inherit these values until a new value is set on a child account.
					</p>
					<div className='col-md-12'>
						<Form.Group>
							<label className="control-label" htmlFor="domain">Domain</label>
							<div className="col-md-9">
								<input type="text" value={domain} className="form-control domain" id="domain" name="domain" required={true} maxLength="63" disabled={isEditDisabled} />
							</div>
						</Form.Group>
						<Form.Group>
							<label className="control-label" htmlFor="4tressAppName">4tress App Name</label>
							<div className="col-md-9">
								<input type="text" value={organization.management && organization.management.appName ? organization.management.appName : "Management appName Error"} className="form-control" id="4tressAppName" name="4tressAppName" required={true} maxLength="63" disabled={isEditDisabled} />
							</div>
						</Form.Group>
						<Form.Group>
							<label className="control-label" htmlFor="4tressSubDomain">4tress Subdomain</label>
							<div className="col-md-9">
								<input type="text" value={organization.management && organization.management.subDomain ? organization.management.subDomain : "Management subdomain error"} className="form-control subdomain" id="4tressSubDomain" name="4tressSubDomain" required={true} maxLength="63" disabled={isEditDisabled} />
							</div>
						</Form.Group>
						<Form.Group>
							<label className="control-label" htmlFor="VT4AppName">VT4 App Name</label>
							<div className="col-md-9">
								<input type="text" value={organization.pos && organization.pos.appName ? organization.pos.appName : "POS appName Error"} className="form-control" id="VT4AppName" name="VT4AppName" required={true} maxLength="63" disabled={isEditDisabled} />
							</div>
						</Form.Group>
						<Form.Group>
							<label className="control-label" htmlFor="VT4SubDomain">VT4 Subdomain</label>
							<div className="col-md-9">
								<input type="text" value={organization.pos && organization.pos.subDomain ? organization.pos.subDomain : "POS subdomain error"} className="form-control subdomain" id="VT4SubDomain" name="VT4SubDomain" required={true} maxLength="63" disabled={isEditDisabled} />
							</div>
						</Form.Group>
						<Form.Group>
							<label className="control-label" htmlFor="SSOAppName">SSO App Name</label>
							<div className="col-md-9">
								<input type="text" value={organization.sso && organization.sso.appName ? organization.sso.appName : "SSO appName error"} className="form-control" id="SSOAppName" name="SSOAppName" required={true} maxLength="63" disabled={isEditDisabled} />
							</div>
						</Form.Group>
						<Form.Group>
							<label className="control-label" htmlFor="SSOSubDomain">SSO Subdomain</label>
							<div className="col-md-9">
								<input type="text" value={organization.sso && organization.sso.subDomain ? organization.sso.subDomain : "SSO subdomain error"} className="form-control subdomain" id="SSOSubDomain" name="SSOSubDomain" required={true} maxLength="63" disabled={isEditDisabled} />
							</div>
						</Form.Group>
					</div>
				</Modal.Body>
				<Modal.Footer className="modal-footer">
					<Button className="btn btn-default" onClick={cancelConfig}>Cancel</Button>
					{
						false == isEditDisabled && (
							<Button onClick={promptConfirmConfig}>Apply</Button>
						)
					}
				</Modal.Footer>
			</Form>
		</Modal>
		<ConfirmationModal
			show={showConfirmOrganizationAppConfigModalSignal.value}
			handleCancel={
				() => {
					showConfirmOrganizationAppConfigModalSignal.value = false
					showSignal.value = true
				}
			}
			handleConfirm={applyConfig}
			message={(
				<>
					<p>Are you sure you want to make changes to domains and app names for this account? This will affect all child accounts under this account that do not have values set.
					</p>
					<p>
						<b>Warning</b>: Do not confirm these changes until both parties are properly set up to accept the new domain, subdomain, and app name values. Putting improper values can prevent all users from this account and child accounts from accessing the listed apps.
					</p>
				</>
			)}
			title={"Confirm Domains &amp; App Names Update"}
			confirmText={"Yes"}
			cancelText={"No"}
		></ConfirmationModal>
	</>)
}
export default OrganizationAppConfigModal